<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {};
  },
  components: {},
  created() {
    this.clearBranch();
  },
  methods: {
    ...mapActions('user', ['clearBranch'])
  }
};
</script>
